exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Loader-module__loader___3AMRf{font-size:40px;display:flex;align-items:center;justify-content:center;width:100%;height:100vh;color:#1e265c;background:#fff}", ""]);

// exports
exports.locals = {
	"loader": "Loader-module__loader___3AMRf"
};